<template lang="pug">
  b-container(v-if="user", fluid)
    b-row
      b-col.page-wrap(cols="12")
        b-card-group.w-100
          b-card(no-body)
            div(slot="header") {{$t('user_page.user_details')}}
            b-list-group(flush)
              // 아이디
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('ID')}}
                  b-col(cols="7" md="9" lg="10") {{user.mail}}
              // 패스워드
              b-list-group-item(v-if="!isDisabledForAdmin")
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('PW')}}
                  b-col(cols="7" md="9" lg="10")
                    div(v-if="!passwd.modify")
                      b-btn.mr-2(size="sm", @click="pwInputChange(true)") {{$t('change')}}
                      b-btn(size="sm", @click="resetPW") {{$t('reset-pw')}}
                    div(v-else)
                      b-form-group(
                        label-size="sm",
                        :description="$t(validatePasswordLevels[this.password_level])",
                        :label="$t('enter_new_password')")
                        b-form-input(type="password", autocomplete="new-password", :state="memberPwState(this.password_level)", v-model.trim="passwd.value", size="sm")
                      b-form-group(
                        label-size="sm",
                        :label="$t('PW_confirm')")
                        b-form-input(type="password", autocomplete="new-password", :state="pwcState", v-model.trim="passwd.confirm", size="sm")
                      b-btn(
                        size="sm",
                        variant="success",
                        :disabled="!memberPwState(this.password_level) || !pwcState",
                        @click="setPassword()",
                        class="mr-2") {{$t('do_change')}}
                      b-btn(size="sm", @click="pwInputChange(false)") {{$t('cancel')}}
              // 결재 프로세스 적용
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.apply_approval_process')}}
                  b-col(cols="7" md="9" lg="10")
                    switches.lmm-switch(
                      v-model="useApproval",
                      theme="bootstrap",
                      :color="useApproval ? 'success' : 'default'",
                      @input="toggleChanged('useApproval', 'use_approval')"
                    )
              // 파일 전송 권한
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.file_transfer_permission')}}
                  b-col(cols="7" md="9" lg="10")
                    switches.lmm-switch(
                      v-model="useAuthFilemanager"
                      theme="bootstrap"
                      :color="useAuthFilemanager ? 'success' : 'default'"
                      @input="toggleChanged('useAuthFilemanager', 'auth_filemanager')"
                    )
              // 사후 결재 권한
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.post_approval_permission')}}
                  b-col(cols="7" md="9" lg="10")
                    switches.lmm-switch(
                      v-model="usePostApproval"
                      theme="bootstrap"
                      :color="usePostApproval ? 'success' : 'default'"
                      @input="toggleChanged('usePostApproval', 'post_approval')"
                    )
              // 사용자 권한
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.user_permissions')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="member_type_id"
                      :value="memberTypeIdPrint"
                      :wait="wait.memberTypeId"
                      :selected="user.member_type_id === 2 ? 3 : user.member_type_id"
                      :list="userAuthList"
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
              // 이름
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('name')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="name"
                      :value="user.name"
                      :wait="wait.name"
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
              // 부서
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('department')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="part_pk"
                      :value="user.department"
                      :wait="wait.department"
                      :selected="user.part_pk"
                      :list="departments"
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
              // 직책
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('cowork_position')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="position"
                      :value="user.position"
                      :wait="wait.position"
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
              // 직급
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.position')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="rank"
                      :value="user.rank"
                      :wait="wait.rank"
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
              // 부서장 여부
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.is_department_head')}}
                  b-col(cols="7" md="9" lg="10")
                    switches.lmm-switch(
                      v-model="departmentLeaderFlag"
                      theme="bootstrap"
                      :disabled="user.part_pk === 1"
                      :color="user.department_leader_flag ? 'success' : 'default'"
                      @input="toggleChanged('departmentLeaderFlag', 'department_leader_flag')"
                    )
              // 본인 결재 승인 단계
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.self_approval_step')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="manage_seq"
                      :value="manageSeqPrint"
                      :wait="wait.manageSeq"
                      :selected="user.manage_seq"
                      :list="managesList"
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
              // 사용 신청 필수 결재 단계
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.mandatory_approval_step_for_use_request')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="approve_seq"
                      :value="approveSeqPrint"
                      :wait="wait.approveSeq"
                      :selected="user.approve_seq"
                      :list="manages.filter(item => item.value !== 9)"
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
              // 등록 매니저
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.registered_manager')}}
                  b-col(cols="7" md="9" lg="10")
                    div {{ user.dev_current }}
                    b-btn.otp-reset-button(size="sm" @click="showDialogManager = true") {{$t('user_page.view_delete')}}
              // 매니저 한도
              b-list-group-item(v-if='accountType === 1')
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.manager_limit')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="mgrdev_limit"
                      :value="user.mgrdev_limit"
                      :wait="wait.mgrdev_limit"
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
              // 등록 원격기기
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.registered_remote_device')}}
                  b-col(cols="7" md="9" lg="10")
                    div {{ user.agent_current }}
                    b-btn.otp-reset-button(size="sm" @click="showDialogAgent = true") {{$t('user_page.view_delete')}}
              // 원격기기 한도
              b-list-group-item
                b-row
                  b-col.label(cols="5" md="3" lg="2") {{$t('user_page.remote_device_limit')}}
                  b-col(cols="7" md="9" lg="10")
                    editable(
                      name="dev_limit"
                      :value="user.dev_limit",
                      :wait="wait.dev_limit",
                      @changed="valueChange"
                      :disabled="isDisabledForAdmin"
                    )
                    
    dialog-manager(:show.sync="showDialogManager" :userPk="parseInt(userPk)" @close="closeManager")
    dialog-agent(:show.sync="showDialogAgent" :userPk="parseInt(userPk)" @close="closeAgent")
    dialog-approver(
      :show.sync="showDialogApprover"
      :title="null"
      :data="{ context: 'middle_manager_list_modal' }"
      @select="selectApprover"
    )
</template>

<script>
import _ from "lodash"
import Switches from "vue-switches"
import { TimezoneConverter } from "@/api/util"
import { UsersAPI, DeviceGroupAPI, ConnDeviceGroupAPI, ApprovalsAPI, DepartmentsAPI, CompanyFunctionAPI } from "@/api"
import store from "@/api/store"
import { setDateFmt, FileUploadAPI, setPermission, user as loginUser } from "@/api/access"
import Editable from "@/components/mixins/editable"
import TzSelect from "@/components/mixins/tzselect"
import ToggleBox from "@/components/mixins/togglebox"
import DialogManager from "../components/dialogManager.vue"
import DialogAgent from "../components/dialogAgent.vue"
import DialogApprover from "../components/dialogApprover.vue"

const permTrgLabels = {
  common: "common",
  web: "web_manager",
  cs: "CS_manager",
}

const User = pk => {
  return (key, value) => {
    if (key === 'member_type_id') {
      key = 'user_type'
    }
    let params = {}
    params[key] = value
    return UsersAPI.put(`${pk}`, params)
  }
}

export default {
  name: "profile-edit-component",
  props: {
    userPk: {
      type: [String, Number],
      required: true,
    },
  },
  components: { Editable, TzSelect, Switches, ToggleBox, DialogManager, DialogAgent, DialogApprover },
  computed: {
    pwState() {
      return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
    },
    pwcState() {
      return this.passwd.value === this.passwd.confirm
    },
    listener() {
      this.AppState.$on("send-department-head-data", data => {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.user.approver_id = data.mgrid
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.user.approver_name = data.name
      })
      return this.user.approver_id + "(" + this.user.approver_name + ")"
    },
    manageSeqPrint() {
      return _.find(this.manages, { value: this.user.manage_seq }).text
    },
    managesList() {
      let result = _.cloneDeep(this.manages)
      if (this.myUser.member_type_id === 1) {
        // 사용자
        result = result.filter(item => item.value === 0)
      }
      return result
    },
    approveSeqPrint() {
      return _.find(this.manages, { value: this.user.approve_seq }).text
    },
    memberTypeIdPrint() {
      const memberTypeId = this.user.member_type_id === 2 ? 3 : this.user.member_type_id
      return _.find(this.userAuth, { value: memberTypeId }).text
    },
    userAuthList() {
      let result = _.cloneDeep(this.userAuth)
      if (this.user.department === 1) {
        // 무소속
        result = result.filter(item => item.value === 1)
      }
      return result
    },
    accountType() {
      return store.get('auth').account_type
    },
    isDisabledForAdmin() {
      // 관리자가 아닌 경우 true를 반환 (관리자일 때는 비활성화되지 않음)
      return this.myUser.member_type_id !== 2 && this.myUser.member_type_id !== 3
    }
  },
  methods: {
    fetchDepartment() {
      DepartmentsAPI.get().then(resp => {
        this.departments = resp.data.objects.map(item => {
          return {
            ...item,
            text: item.part_name,
            value: item.pk,
          }
        })
      })
    },
    closeManager(count) {
      this.showDialogManager = false
      this.user.dev_current = count
    },
    closeAgent(count) {
      this.showDialogAgent = false
      this.user.agent_current = count
    },
    resetOTP() {
      let params = {
        context: { path: "reset_n", args: { v: "OTP" } },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: "submit",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key === "submit") {
          this.userUpdate("flag_create_qrcode", false)
            .then(() => {
              this.AppState.$emit("show-message-dialog", { context: { path: "otp_reset_complete" } })
            })
            .catch(err => {
              console.error(err)
              this.AppState.$emit("show-message-dialog", { context: { path: "otp_reset_failed" } })
            })
        }
      })
    },
    resetPW() {
      let params = {
        context: { path: "reset-pw-repeat" },
        withoutInput: true,
        submit: {
          size: "sm",
          color: "danger",
          text: "submit",
        },
      }
      this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
        if (key === "submit") {
          // this.AppState.$emit('show-message-dialog', { context: {path: 'reset-pw-submit'} })
          this.userUpdate("pw", "koino1807!")
            .then(resp => {
              this.AppState.$emit("show-message-dialog", { context: { path: "reset-pw-submit" } })
              this.pwInputChange(false)
            })
            .catch(resp => {
              this.AppState.$emit("show-message-dialog", { context: { path: "password_modified_failed" } })
              this.pwInputChange(false)
            })
        }
      })
    },
    permisionSubmit() {
      this.permissionUpdating = true
      let authVal = 0
      if (this.permissions[0].value === true) authVal += 1 // deviceMonitor
      // if (this.permissions[3].value === true) authVal += 2 // modifyInformation
      if (this.permissions[3].value === true) authVal += 4 // useFunction
      if (this.permissions[4].value === true) authVal += 8 // viewReport

      let params = {
        auth_devicemanagement: _.find(this.permissions, { key: "CSDeviceManagement" }).value,
        auth_filemanager: _.find(this.permissions, { key: "CSFileManager" }).value,
        auth_remotecontrol: _.find(this.permissions, { key: "CSRemoteControl" }).value,
        // auth_remoteview: _.find(this.permissions, {key: 'CSRemoteView'}).value,
        auth_restart: _.find(this.permissions, { key: "CSRestart" }).value,
        auth_thumbnailview: _.find(this.permissions, { key: "CSThumbnailView" }).value,
        auth_update: _.find(this.permissions, { key: "CSUpdate" }).value,
        auth_val: authVal,
      }

      UsersAPI.put(`${this.userPk}`, params).then(resp => {
        this.permissionUpdating = false
      })
    },
    permissionChange(index, value) {
      this.permissions[index].value = value
      this.permisionSubmit()
    },
    groupAccessChange(index, value, restore) {
      const { pk } = this.groups[index]
      if (value) {
        let params = {
          device_group_fk: pk,
          member_fk: this.userPk,
        }
        ConnDeviceGroupAPI.post("", params).then(() => {
          ConnDeviceGroupAPI.get("", { params }).then(resp => {
            this.groups[index].connectedPk = resp.data.objects[0].pk
            this.groups[index].connected = true
          })
        })
      } else {
        ConnDeviceGroupAPI.delete(`${this.groups[index].connectedPk}`).then(() => {
          this.groups[index].connectedPk = null
          this.groups[index].connected = false
        })
      }
    },
    // 하위 그룹 권한을 생성/제거시 상위 그룹에 영향을 받음
    // 2018-11-28 헬스케어 관련 수정으로 기능을 없앰
    groupAccessChange_backup(index, value, restore) {
      const { pk, path, child } = this.groups[index]

      if (value) {
        if (path.length) {
          let notConnectedParents = path.filter(v => !v.connected)
          if (notConnectedParents.length) {
            restore(false)

            let params = {
              context: { path: "add_permission_of_group", args: { groups: notConnectedParents.map(v => v.name).join(", ") } },
              withoutInput: true,
              submit: {
                size: "sm",
                color: "primary",
                text: { path: "submit" },
              },
            }
            this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
              if (key !== "submit") return
              // 상위 장치그룹 허용
              _.each(notConnectedParents, parent => {
                let params = {
                  device_group_fk: parent.pk,
                  member_fk: this.userPk,
                }
                ConnDeviceGroupAPI.post("", params).then(() => {
                  ConnDeviceGroupAPI.get("", { params }).then(resp => {
                    parent.connectedPk = resp.data.objects[0].pk
                    parent.connected = true
                  })
                })
              })
              // 장치그룹 허용
              let params = {
                device_group_fk: pk,
                member_fk: this.userPk,
              }
              ConnDeviceGroupAPI.post("", params).then(() => {
                ConnDeviceGroupAPI.get("", { params }).then(resp => {
                  this.groups[index].connectedPk = resp.data.objects[0].pk
                  this.groups[index].connected = true
                })
              })
            })
            return
          }
        }
        // 상위 그룹이 다 허용된 경우
        let params = {
          device_group_fk: pk,
          member_fk: this.userPk,
        }
        ConnDeviceGroupAPI.post("", params).then(() => {
          ConnDeviceGroupAPI.get("", { params }).then(resp => {
            this.groups[index].connectedPk = resp.data.objects[0].pk
            this.groups[index].connected = true
          })
        })
      } else {
        if (child.length) {
          let connectedParents = child.filter(v => v.connected)
          if (connectedParents.length) {
            restore(true)

            let params = {
              context: { path: "delete_permission_of_group", args: { groups: connectedParents.map(v => v.name).join(", ") } },
              withoutInput: true,
              submit: {
                size: "sm",
                color: "primary",
                text: { path: "submit" },
              },
            }
            this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
              if (key !== "submit") return
              // 하위 장치그룹 권한 제거
              _.each(connectedParents, children => {
                ConnDeviceGroupAPI.delete(`${children.connectedPk}`).then(() => {
                  children.connectedPk = null
                  children.connected = false
                })
              })
              // 장치그룹 권한 제거
              ConnDeviceGroupAPI.delete(`${this.groups[index].connectedPk}`).then(() => {
                this.groups[index].connectedPk = null
                this.groups[index].connected = false
              })
            })
            return
          }
        }

        ConnDeviceGroupAPI.delete(`${this.groups[index].connectedPk}`).then(() => {
          this.groups[index].connectedPk = null
          this.groups[index].connected = false
        })
      }
    },
    pwInputChange(state) {
      this.passwd.modify = state
      this.passwd.value = ""
      this.passwd.confirm = ""
    },
    setPassword() {
      this.userUpdate("pw", this.passwd.value)
        .then(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "password_modified" } })
          this.pwInputChange(false)
        })
        .catch(resp => {
          this.AppState.$emit("show-message-dialog", { context: { path: "password_modified_failed" } })
          this.pwInputChange(false)
        })
    },
    dateFmtChange(value) {
      this.userUpdate("date_fmt_id", value).then(resp => {
        let r = setDateFmt(value)
        this.AppState.Info.dateFmt = r.value
      })
    },
    uploadLogo(data) {
      var file = null
      if (data.target) file = data.target.files[0]
      else file = data
      const fd = new FormData()
      fd.append("file", file)

      FileUploadAPI.post("", fd).then(resp => {
        this.AppState.$emit("logo-changed")
        this.timestamp = new Date().getTime()
      })
    },
    toggleChanged(dataKey, dbKey) {
      if (!this.pageMounted) return
      if (dataKey === "departmentLeaderFlag") {
        let params = {}
        params.department_leader_flag = this[dataKey]
        params.part_pk = this.user.part_pk
        UsersAPI.put(`${this.user.pk}`, params)
        this.user.department_leader_flag = this[dataKey]
        return
      }
      this.userUpdate(dbKey, this[dataKey])
    },
    async toggleSubManager(dataKey, dbKey) {
      let params = this.user.member_type_id
      if (this.useSubManager) {
        params = 6
      } else if (this.useAdmin) {
        params = 2
      }
      this.userUpdate(dbKey, params)
    },
    valueChange(key, value) {
      if (key === "mgrdev_limit") {
        if (value < this.user.dev_current) {
          this.AppState.$emit("show-message-dialog", {
            context: {
              path: 'user_page.manager_limit_exceeded',
            },
          })
          this.user.mgrdev_limit = ""
          this.$nextTick(() => {
            this.user.mgrdev_limit = this.user.origin_mgrdev_limit
          })
          return
        }
      }
      if (key === "dev_limit") {
        if (this.user.total_dev_limit < value) {
          this.AppState.$emit("show-message-dialog", {
            context: {
              path: this.$t("user_page.dev_limit_exceeded", { totalDevLimit: this.user.total_dev_limit }),
            },
          })
          this.user.dev_limit = ""
          this.$nextTick(() => {
            this.user.dev_limit = this.user.origin_dev_limit
          })
          return
        }
        
        if (value < this.user.agent_current) {
          this.AppState.$emit("show-message-dialog", {
            context: {
              path: 'user_page.remote_device_limit_exceeded',
            },
          })
          this.user.dev_limit = ""
          this.$nextTick(() => {
            this.user.dev_limit = this.user.origin_dev_limit
          })
          return
        }
      }
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}]`)
      this.wait[key] = true
      this.userUpdate(key, value)
        .then(resp => {
          this.wait[key] = false
        })
        .catch(err => {
          this.wait[key] = false
        })
    },
    async approverChange(key, value) {
      this.$log.debug(`[CHANGED KEY: ${key}, VALUE: ${value}]`)
      this.wait[key] = true
      let params = {
        name: value,
      }
      const resp = await ApprovalsAPI.get("search", { params })
      if (resp.data.status === 200) {
        let params = {
          approver_fk: resp.data.objects[0].pk,
          user_type: this.user.member_type_id,
        }
        UsersAPI.put(`${this.userPk}`, params).then(resp => {
          // this.AppState.$emit('show-message-dialog', {
          //   title: 'LinkMeMine',
          //   context: {path: 'search_manager_200'}
          // })
          this.wait[key] = false
        })
      } else {
        let params = {
          context: { path: "search_manager_405" },
          withoutInput: true,
          withoutCancel: true,
          submit: {
            size: "sm",
            color: "danger",
            text: "submit",
          },
        }
        this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
          if (key === "submit") {
            this.$router.go(this.$router.currentRoute)
          }
        })
      }
      this.wait[key] = false
    },
    timezoneChanged(tz) {
      let id = TimezoneConverter("offset", tz.offset)
      if (id) {
        let tzv = _.assign({}, id, tz)
        this.AppState.Info.timezone = tzv
        this.AppState.$emit("timezone-changed")
      }
    },
    async getData() {
      const resp = await CompanyFunctionAPI.get()

      this.password_level = resp.data.objects[0].password_level
    },
    getUserData() {
      this.getData()
      UsersAPI.get(`${this.userPk}`).then(resp => {
        let user = resp.data.objects
        this.dateFormat.value = user.date_fmt_id
        this.useOtp = user.flag_use_otp
        this.useRefresh = user.flag_refresh
        this.useLiveviewRefresh = user.flag_img_refresh
        this.useApproval = user.use_approval
        this.departmentLeaderFlag = user.department_leader_flag
        this.usePostApproval = user.post_approval
        this.useAuthFilemanager = user.auth_filemanager
        this.timestamp = new Date().getTime()
        let perms = setPermission(user, true)
        _.each(this.permissions, v => {
          if (perms[v.key]) {
            v.value = perms[v.key]
          }
        })
        this.user = user
        this.user.origin_mgrdev_limit = _.clone(this.user.mgrdev_limit)
        this.user.origin_dev_limit = _.clone(this.user.dev_limit)
        this.user.total_dev_limit = loginUser().license.total.vol
        this.userUpdate = User(user.pk)
        this.$nextTick(() => {
          this.pageMounted = true
        })
        // disable_filetransfer
        if (user.disable_filetransfer) {
          for (let i = 0; i < this.permissions.length; i++) {
            if (this.permissions[i].key == "CSFileManager") {
              this.permissions[i].disabled = true
            }
          }
        }

        // 중간관리자권한 GET
        if (user.member_type_id === 6) {
          this.useSubManager = true
        } else if (user.member_type_id === 1) {
          this.useSubManager = false
        } else if (user.member_type_id === 2 || user.member_type_id === 3) {
          this.useAdmin = true
        }
      })
    },
    memberPwState(passwordLevel) {
      if (passwordLevel === 0) return /^.{4,12}$/.test(this.passwd.value)
      if (passwordLevel === 1) return /^(?=.*?[a-zA-Z])(?=.*?[0-9]).{6,12}$/.test(this.passwd.value)
      if (passwordLevel === 2) return /^(?=.*?[a-zA-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
      if (passwordLevel === 3) return /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,12}$/.test(this.passwd.value)
    },
    getGroups() {
      const pushParent = (groups, order, path, group) => {
        let g = groups.filter(v => v.pk === group.group_fk)
        if (g.length) {
          g = g[0]
          path.unshift(g)
          order.unshift(g.name[0].charCodeAt())
          if (g.group_fk) pushParent(groups, order, path, g)
        }
      }
      const pushChild = (groups, child, group) => {
        let g = groups.filter(v => v.group_fk === group.pk)
        if (g.length) {
          child.push.apply(child, g)
          _.each(g, c => pushChild(groups, child, c))
        }
      }
      const groupSort = groups => {
        groups = groups.map(v => {
          let path = []
          let child = []
          let order = v.name ? [v.name[0].charCodeAt()] : [0]
          if (v.group_fk) pushParent(groups, order, path, v)
          pushChild(groups, child, v)
          v.location = path.length ? "/" + path.map(v => v.name).join("/") + "/" : "/"
          v.path = path
          v.child = child
          v.order = order
          v.order1 = order.length * -1
          v.connected = false
          v.connectedPk = null
          return v
        })
        this.groups = _.sortBy(groups, ["order", "order1"])
        this.getConnGroups()
      }
      let stored = store.get("devices")
      if (stored !== undefined && stored.groups) {
        let groups = stored.groups
        groupSort(groups)
      } else {
        DeviceGroupAPI.get("").then(resp => {
          let groups = resp.data.objects
          groupSort(groups)
        })
      }
    },
    onModal() {
      let params = {
        title: "LinkMeMine",
        context: { path: "middle_manager_list_modal" },
        userPk: this.userPk,
        userType: this.user.member_type_id,
      }
      this.AppState.$emit("show-list-modal-dialog", params)
    },
    async selectApprover(item) {
      this.showDialogApprover = false

      UsersAPI.put(`${this.userPk}`, { approver_fk: item.pk, user_type: this.user.member_type_id })
        .then(res => {
          this.AppState.$emit("send-department-head-data", {
            mgrid: item.id,
            name: item.name,
          })
        })
        .catch(error => {
          let params = {
            context: { path: "search_manager_405" },
            withoutInput: true,
            withoutCancel: true,
            submit: {
              size: "sm",
              color: "danger",
              text: "submit",
            },
          }
          this.AppState.$emit("show-confirm-dialog", params, (key, data) => {
            if (key === "submit") {
              this.$router.go(this.$router.currentRoute)
            }
          })
        })
    },
  },
  created() {
    this.fetchDepartment()
    this.getUserData()
  },
  data() {
    return {
      myUser: store.get("user"),
      password_level: null,
      validatePasswordLevels: [this.$t("password_level0"), this.$t("password_level1"), this.$t("password_level2"), this.$t("password_level3")],
      manages: [
        { value: 0, text: this.$t('user_page.not_set') },
        { value: 9, text: this.$t('user_page.global_settings') },
        { value: 1, text: `1${this.$t('user_page.step')}` },
        { value: 2, text: `2${this.$t('user_page.step')}` },
        { value: 3, text: `3${this.$t('user_page.step')}` },
        { value: 4, text: `4${this.$t('user_page.step')}` },
      ],
      userAuth: [
        { value: 1, text: this.$t('user') },
        { value: 6, text: this.$t('mid_manager') },
        { value: 3, text: this.$t('policy_manager') },
      ],
      timestamp: 0,
      groups: [],
      pageMounted: false,
      user: null,
      managedUser: {},
      wait: {
        email: false,
        name: false,
        phone: false,
        tel: false,
        department: false,
        position: false,
        refresh_interval: false,
        approver_name: false,
        manageSeq: false,
        approveSeq: false,
        memberTypeId: false,
      },
      useOtp: false,
      useRefresh: false,
      useLiveviewRefresh: false,
      useApproval: false,
      departmentLeaderFlag: false,
      usePostApproval: false,
      useAuthFilemanager: false,
      afterPaymentFlag: false,
      useSubManager: false,
      useAdmin: false,
      dateFormat: {
        value: null,
        options: [
          { value: 0, text: "YYYY/MM/DD" },
          { value: 1, text: "MM/DD/YYYY" },
          { value: 2, text: "DD/MM/YYYY" },
        ],
      },
      passwd: {
        modify: false,
        value: "",
        confirm: "",
      },
      permissionUpdating: false,
      permissions: [
        {
          key: "deviceMonitor",
          lang: "permissions.deviceMonitor",
          target: permTrgLabels.common,
          value: false,
          disabled: true,
        },
        {
          key: "CSRemoteControl",
          lang: "permissions.CSRemoteControl",
          target: permTrgLabels.common,
          value: false,
        },
        {
          key: "CSFileManager",
          lang: "permissions.CSFileManager",
          target: permTrgLabels.common,
          value: false,
          disabled: false,
        },
      ],
      showDialogManager: false,
      showDialogAgent: false,
      showDialogApprover: false,
      departments: [],
    }
  },
}
</script>

<style lang="scss" scoped>
.row,
.col,
.container-fluid,
.col-12 {
  margin: 0;
  padding: 0;
}

.page-wrap {
  padding: 1rem 1.5rem;
}

.profile-image {
  max-width: 240px;
  margin: 0 auto;
  overflow: hidden;
}
.logo-wrap {
  position: relative;
}
.profile-image-upload {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  z-index: 10;
  overflow: hidden;
  display: block;
  background-color: rgba(0, 0, 0, 0.3);
  cursor: pointer;
  opacity: 0;
  transition: opacity 300ms;
  &.dragover,
  &:hover {
    opacity: 1;
  }

  .upload-icon {
    display: block;
    margin: 12px auto 0;
    color: #fff;
  }
}

#upload {
  position: absolute;
  bottom: -30px;
}
.otp-reset-button {
  position: absolute;
  top: 50%;
  right: 5px;
  transform: translateY(-50%);
}

.list-group-item {
  padding: 4px;
}

.label {
  display: flex;
  align-items: center;
  min-height: 38px;
  & + div {
    display: flex;
    align-items: center;
  }
}

::v-deep {
  .editable-wrapper .edit-buttons {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>